import * as commonConsts from '../../pages/common/CommonConsts';
import * as constants from '../../utils/Constants';
import { getDuplicateAddressDetail, isPrimaryContact } from '../../utils/Helper';
import { getIndividualApplicantDetails } from './Helper';
import { getSingleAddressDetail } from '../../utils/notificationChange/Helper';
import moment from 'moment';
import { getDocuments } from '../../utils/SupportingDocumentHelper';

const formattedIndividualNotificationChangeJson = (
  application,
  twoFA,
  authorityInformation,
  licenceFullDetail,
  notificationChangeDetail
) => {
  const {
    individualLicence,
    individualAuthorityHolder,
    accountant,
    trader,
    fundraisingDetail,
    supportingDocument
  } = notificationChangeDetail;

  const { licenceInfo } = licenceFullDetail;
  const { twoFaVerified, data } = twoFA;

  let associatedIndividuals = [];
  let associatedOrganisations = [];
  let premiseList = [];
  let individualAuthorityHolderAddresses = null;

  let individualLicenceData = {};
  //#region Authority Holder Details
  const individualApplicationDetails = getIndividualApplicantDetails(
    individualLicence,
    individualAuthorityHolder,
    twoFA,
    licenceInfo
  );
  //#endregion

  //#region Authority Holder Name Change
  //authority name change is handled in getIndividualApplicantDetails
  //#endregion

  //#region Premise Addresses
  if (individualApplicationDetails?.residentialAddress && individualApplicationDetails?.postalAddress) {
    let premiseAddresses = [];

    premiseAddresses = premiseAddresses.concat(individualApplicationDetails.residentialAddress);
    premiseAddresses = premiseAddresses.concat(individualApplicationDetails.postalAddress);

    if (premiseAddresses?.length > 0) {
      const individualAuthorityHolderName = individualApplicationDetails?.middleName
        ? `${individualApplicationDetails?.firstName} ${individualApplicationDetails?.middleName} ${individualApplicationDetails?.lastName}`
        : `${individualApplicationDetails?.firstName} ${individualApplicationDetails?.lastName}`;

      premiseList = premiseList.concat({
        businessName: individualAuthorityHolderName,
        id: individualApplicationDetails?.partyRowId,
        integrationId: individualApplicationDetails?.integrationId,
        roles: ['Registered Office'],
        premiseAddresses: premiseAddresses
      });

      //#region Authority Holder Addresses
      // if(licenceInfo?.individualLicensee?.addresses) {
      //   let missingAddrTypes = ['Residential','Postal']
      //   licenceInfo.individualLicensee.addresses.map((addr) => {
      //     missingAddrTypes = missingAddrTypes.filter((addrType) => addrType === addr.addressType);
      //   });

      //   if(missingAddrTypes?.length > 0) {
      //     missingAddrTypes.map((addrType) => {
      //       individualAuthorityHolderAddresses = individualAuthorityHolderAddresses.concat(
      //         premiseAddresses.find((premAddr) => premAddr.addressType === addrType)
      //       );
      //     });
      //   }
      // }
      individualAuthorityHolderAddresses = premiseAddresses;

      //#endregion
    }
  }

  //#endregion

  //#region Accountants
  if (accountant) {
    //New Accountants
    if (accountant?.newAccountants?.length > 0) {
      accountant.newAccountants.forEach((newAccountant) => {
        if (newAccountant.partyType === commonConsts.OptionsIndividual) {
          associatedIndividuals = associatedIndividuals.concat({
            firstName: newAccountant?.firstName,
            middleName: newAccountant?.middleName,
            surname: newAccountant?.lastName,
            contactPart: {
              emailAddress: newAccountant?.emailAddress,
              phoneNo: newAccountant?.primaryContactNumber
                ? `${newAccountant.primaryContactNumber?.prefix}-${newAccountant.primaryContactNumber?.number}`
                : ``
              // phoneNo: newAccountant?.secondaryContactNumber
              //   ? `${newAccountant.secondaryContactNumber?.prefix}-${newAccountant.secondaryContactNumber?.number}`
              //   : ``
            },
            addresses: getDuplicateAddressDetail(newAccountant?.businessAddress, newAccountant?.postalAddress),
            qualifications: [
              {
                certificateNumber: newAccountant?.qualification?.certificateNumber,
                certificateName: newAccountant?.qualification?.qualifications,
                details: newAccountant?.qualification?.details
              }
            ],
            roleDetails: [
              {
                roleType: 'Auditor',
                startDate: moment(new Date()).format('DD/MM/YYYY')
              }
            ],
            roles: []
          });
        } else {
          associatedOrganisations = associatedOrganisations.concat({
            id: newAccountant?.siebelRowId ? newAccountant?.siebelRowId : null,
            integrationId: newAccountant?.integrationId ? newAccountant?.integrationId : null,
            name: newAccountant?.businessName,
            abn: newAccountant?.organisationData?.abn,
            acn: newAccountant?.organisationData?.acn,
            registrationNumber:
              newAccountant.organisationSearch.searchCriteria?.searchType ===
              commonConsts.OrganisationSearchYincOtherTypeName
                ? newAccountant?.registrationNumber
                : newAccountant?.organisationData?.yincOther,
            roleDetails: [
              {
                roleType: 'Auditor',
                startDate: moment(new Date()).format('DD/MM/YYYY')
              }
            ],
            roles: [],
            addresses: getDuplicateAddressDetail(newAccountant?.businessAddress, newAccountant?.postalAddress)
          });

          //New Lead Accountant
          if (newAccountant?.organisationDetails) {
            const leadAuditor = newAccountant?.organisationDetails;
            associatedIndividuals = associatedIndividuals.concat({
              firstName: leadAuditor?.contactFirstName,
              middleName: leadAuditor?.contactMiddleName,
              surname: leadAuditor?.contactLastName,
              contactPart: {
                emailAddress: leadAuditor?.contactEmailAddress,
                phoneNo: leadAuditor?.contactPrimaryContactNumber
                  ? `${leadAuditor?.contactPrimaryContactNumber?.prefix}-${leadAuditor?.contactPrimaryContactNumber?.number}`
                  : ``
              },
              addresses: getDuplicateAddressDetail(
                leadAuditor?.contactBusinessAddress,
                leadAuditor?.contactPostalAddress
              ),
              qualifications: [
                {
                  certificateNumber: leadAuditor?.contactQualification?.certificateNumber,
                  certificateName: leadAuditor?.contactQualification?.qualifications,
                  details: leadAuditor?.contactQualification?.details
                }
              ],
              relatedOrgName: newAccountant?.businessName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  startDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          }
        }
      });
    }

    //Updated Accountants
    if (accountant?.existingAccountants?.length > 0) {
      accountant.existingAccountants.forEach((existingAccountant) => {
        if (existingAccountant?.isUpdated) {
          if (existingAccountant.partyType === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              id: existingAccountant?.id,
              integrationId: existingAccountant?.integrationId,
              firstName: existingAccountant?.firstName,
              middleName: existingAccountant?.middleName ? existingAccountant.middleName : null,
              surname: existingAccountant?.lastName,
              qualifications: [
                {
                  certificateNumber: existingAccountant?.qualification?.certificateNumber,
                  certificateName: existingAccountant?.qualification?.qualifications,
                  details: existingAccountant?.qualification?.details
                }
              ],
              roleDetails: [
                {
                  roleType: 'Auditor'
                }
              ],
              roles: []
            });
          } else {
            const isLeadAccountantDetails = existingAccountant?.isLeadAccountantDetails;

            if (isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption1) {
              const leadAuditor = existingAccountant?.leadAuditor;

              associatedIndividuals = associatedIndividuals.concat({
                id: leadAuditor?.id,
                integrationId: leadAuditor?.integrationId,
                firstName: leadAuditor?.firstName,
                middleName: leadAuditor?.middleName ? existingAccountant.middleName : null,
                surname: leadAuditor?.lastName,
                qualifications: [
                  {
                    certificateNumber: leadAuditor?.qualification?.certificateNumber,
                    certificateName: leadAuditor?.qualification?.qualifications,
                    details: leadAuditor?.qualification?.details
                  }
                ],
                relatedOrgName: existingAccountant?.businessName,
                roleDetails: [
                  {
                    roleType: 'Auditor'
                  }
                ],
                roles: []
              });
            } else if (isLeadAccountantDetails === commonConsts.organisationLeadAccountantOption2) {
              const newLeadAuditor = existingAccountant?.newLeadAuditor;

              associatedIndividuals = associatedIndividuals.concat({
                firstName: newLeadAuditor?.firstName,
                middleName: newLeadAuditor?.middleName,
                surname: newLeadAuditor?.lastName,
                contactPart: {
                  emailAddress: newLeadAuditor?.emailAddress,
                  phoneNo: newLeadAuditor?.primaryContactNumber
                    ? `${newLeadAuditor?.primaryContactNumber?.prefix}-${newLeadAuditor?.primaryContactNumber?.number}`
                    : ``
                },
                addresses: getDuplicateAddressDetail(newLeadAuditor?.businessAddress, newLeadAuditor?.postalAddress),
                qualifications: [
                  {
                    certificateNumber: newLeadAuditor?.qualification?.certificateNumber,
                    certificateName: newLeadAuditor?.qualification?.qualifications,
                    details: newLeadAuditor?.qualification?.details
                  }
                ],
                relatedOrgName: existingAccountant?.businessName,
                roles: [],
                roleDetails: [
                  {
                    roleType: 'Auditor',
                    startDate: moment(new Date()).format('DD/MM/YYYY')
                  }
                ]
              });
            }
          }
        }
      });
    }

    //Removed Accountants
    if (accountant?.removedAccountants?.length > 0) {
      accountant.removedAccountants.forEach((removedAccountant) => {
        if (removedAccountant?.id && removedAccountant?.integrationId) {
          if (removedAccountant?.partyType === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              id: removedAccountant?.id,
              integrationId: removedAccountant?.integrationId,
              firstName: removedAccountant?.firstName,
              middleName: removedAccountant?.middleName ? removedAccountant.middleName : null,
              surname: removedAccountant?.lastName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  endDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          } else {
            const leadAccountant = removedAccountant?.leadAuditor;

            associatedOrganisations = associatedOrganisations.concat({
              id: removedAccountant?.id,
              integrationId: removedAccountant?.integrationId,
              name: removedAccountant?.businessName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  endDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });

            associatedIndividuals = associatedIndividuals.concat({
              id: leadAccountant?.id,
              integrationId: leadAccountant?.integrationId,
              firstName: leadAccountant?.firstName,
              middleName: leadAccountant?.middleName ? leadAccountant.middleName : null,
              surname: leadAccountant?.lastName,
              roles: [],
              roleDetails: [
                {
                  roleType: 'Auditor',
                  endDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          }
        }
      });
    }
  }
  //#endregion

  //#region Traders
  if (trader) {
    if (trader?.newTraders?.length > 0) {
      trader.newTraders.forEach((newTrader) => {
        if (!!!newTrader?.id && !!!newTrader?.integrationId) {
          if (newTrader?.type === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              firstName: newTrader?.firstName,
              middleName: newTrader?.middleName,
              surname: newTrader?.lastName,
              contactPart: {
                emailAddress: newTrader?.emailAddress,
                phoneNo: newTrader?.primaryContact
                  ? `${newTrader?.primaryContact?.prefix}-${newTrader?.primaryContact?.number}`
                  : ``
              },
              addresses: getDuplicateAddressDetail(newTrader?.businessAddress, newTrader?.postalAddress),
              roles: [],
              roleDetails: [
                {
                  roleType: 'Trader',
                  startDate: moment(new Date()).format('DD/MM/YYYY')
                }
              ]
            });
          } else {
            associatedOrganisations = associatedOrganisations.concat({
              id: newTrader?.orgDataInfo?.data?.siebelRowId,
              integrationId: newTrader?.orgDataInfo?.data?.siebelIntegrationId,
              name: newTrader.organisationName,
              emailAddress: newTrader.organisationEmailAddress,
              phoneNumber:
                newTrader.organisationPrimaryContact.prefix && newTrader.organisationPrimaryContact.number
                  ? `${newTrader.organisationPrimaryContact.prefix}-${newTrader.organisationPrimaryContact.number}`
                  : '',
              addresses: getDuplicateAddressDetail(
                newTrader?.organisationBusinessAddress,
                newTrader?.organisationPostalAddress
              ),
              abn: newTrader?.orgDataInfo?.data?.abn,
              acn: newTrader?.orgDataInfo?.data?.acn,
              registrationNumber:
                newTrader.orgDataInfo.searchCriteria.searchType === commonConsts.OrganisationSearchYincOtherTypeName
                  ? newTrader.registrationNumber
                  : null,
              roleDetails: [
                {
                  roleType: 'Trader',
                  // StartDate: organisation.startDate
                  startDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          }
        }
      });
    }

    if (trader?.removedTraders?.length > 0) {
      trader.removedTraders.forEach((removedTrader) => {
        if (removedTrader?.isExists) {
          if (removedTrader?.type === commonConsts.OptionsIndividual) {
            associatedIndividuals = associatedIndividuals.concat({
              id: removedTrader?.id,
              integrationId: removedTrader?.integrationId,
              firstName: removedTrader?.firstName,
              middleName: removedTrader?.middleName ? removedTrader.middleName : null,
              surname: removedTrader?.lastName,
              roleDetails: [
                {
                  roleType: 'Trader',
                  endDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          } else {
            associatedOrganisations = associatedOrganisations.concat({
              id: removedTrader?.id,
              integrationId: removedTrader?.integrationId,
              name: removedTrader?.organisationName,
              roleDetails: [
                {
                  roleType: 'Trader',
                  endDate: moment(new Date()).format('YYYY-MM-DD')
                }
              ],
              roles: []
            });
          }
        }
      });
    }
  }
  //#endregion

  const authorityHolderName = individualAuthorityHolder?.authorityHolderName
    ? individualAuthorityHolder.authorityHolderName
    : individualApplicationDetails?.middleName
    ? `${individualApplicationDetails.firstName} ${individualApplicationDetails.middleName} ${individualApplicationDetails.lastName}`
    : `${individualApplicationDetails.firstName} ${individualApplicationDetails.lastName}`;

  const contactId = licenceInfo?.individualLicensee?.id;

  let result = {
    agencyId: licenceInfo.agencyId,
    agencyCode: licenceInfo.adgencyCode,
    licenceNumber: licenceInfo.licenceNumber,
    licenceType: licenceInfo.licenceType,
    licenceTypeId: licenceInfo.licenceTypeId,
    licenceId: licenceInfo.licenceId,
    applicationId: application.applicationId,
    contactId: contactId,
    applicationNo: application.applicationNo,
    applicantType: constants.APPLICANT_TYPE_Individual,
    applicationType: constants.APPLICATION_TYPE_NotificationChange,
    associatedIndividuals: associatedIndividuals,
    associatedOrganisations: associatedOrganisations,
    twoFaVerified: twoFA.data ? true : false,
    fundRaisingDetail: {
      charityObjects: fundraisingDetail?.charityObject,
      natureDuration: fundraisingDetail?.natureDuration,
      financialYearEnd:
        fundraisingDetail?.day && fundraisingDetail?.month
          ? `${fundraisingDetail.day}/${fundraisingDetail.month}`
          : fundraisingDetail?.day,
      charityWebsiteUrl: fundraisingDetail?.charityWebsiteUrl
    },
    individualApplicantDetails: {
      roles: ['Licensee'],
      roleDetails: [
        {
          roleType: 'Licensee',
          isPrimary: false
        }
      ],
      id: individualApplicationDetails.partyRowId,
      integrationId: individualApplicationDetails.integrationId,
      firstName: individualAuthorityHolder?.firstName
        ? individualAuthorityHolder?.firstName
        : individualApplicationDetails.firstName,
      middleName: individualAuthorityHolder?.middleName
        ? individualAuthorityHolder?.middleName
        : individualApplicationDetails.middleName,
      surname: individualAuthorityHolder?.lastName
        ? individualAuthorityHolder?.lastName
        : individualApplicationDetails.lastName,
      dateofbirth: individualApplicationDetails.dateOfBirth
        ? moment(individualApplicationDetails.dateOfBirth).format('DD/MM/YYYY')
        : null,
      placeOfBirth: null,
      twoFaVerified: data ? true : false,
      hasOtherNames: false,
      otherNames: null,
      identificationDetails: null,
      contactPart: {
        emailAddress: individualApplicationDetails.emailAddress,
        mobileNo: individualApplicationDetails.mobile,
        phoneNo:
          individualApplicationDetails?.secondaryContact?.prefix &&
          individualApplicationDetails?.secondaryContact?.number
            ? `${individualApplicationDetails.secondaryContact.prefix}-${individualApplicationDetails.secondaryContact.number}`
            : null
      },
      addresses: individualAuthorityHolderAddresses
    },
    premisesList: premiseList,
    attachments:
      supportingDocument?.documents && supportingDocument?.documents?.length > 0
        ? getDocuments(supportingDocument?.documents)
        : null
  };

  return result;
};

export { formattedIndividualNotificationChangeJson };
